import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { redirectBetaUserToMeridian } from "../actions/shared/individualActions";
import { GET } from "../util/apiHelpers";
import { storageAvailable } from "../util/storageHelpers";

const RECHECK_INTERVAL_MS = 5 * 60 * 1000;
const MIN_GAP_MS = 60 * 1000;
const SKIP_PATHS = /login|public/;

// Bootstrap asks /me once per page load, so a tab open when its org went beta never learns to
// leave. Re-ask on route change and on a timer; feed only the redirect, not processIndividual.
export default function useBetaRedirectRecheck() {
  const { pathname } = useLocation();
  const lastCheckedAt = useRef(Date.now());

  useEffect(() => {
    if (!storageAvailable()) return undefined;

    const recheck = async () => {
      if (!localStorage.getItem("authToken")) return;
      if (SKIP_PATHS.test(window.location.pathname)) return;
      if (window.location.search.includes("meridian_attempt=")) return;
      if (Date.now() - lastCheckedAt.current < MIN_GAP_MS) return;
      lastCheckedAt.current = Date.now();

      try {
        const location = encodeURIComponent(
          window.location.pathname + window.location.search
        );
        const res = await GET(`/api/v3/authentication/me?pathname=${location}`);
        await redirectBetaUserToMeridian(res.data);
      } catch {
        // Nothing to do; bootstrap handles a real 401.
      }
    };

    recheck();
    const intervalId = setInterval(recheck, RECHECK_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, [pathname]);
}
